import React from 'react';
import styles from './ChallengeCard.module.css';
import moment from 'moment';
import AppMark from '../../../../shared/project-info/web-project-info/svgs/AppMark';
import {
  isUpcomingChallenge,
  howLongUntil,
} from '../../../../shared/utils/ChallengeHelpers';

const ChallengeCardHeader = ({title, endTime, ended, startTime, badgeURL}) => {
  return (
    <div className={styles.topContainer}>
      <div className={styles.titleAndTimeContainer}>
        <p className={styles.title}>{title}</p>
        {ended ? (
          <h5>Ended {moment(endTime).format('MMM DD, YYYY')}</h5>
        ) : (
          <h5>
            {startTime && isUpcomingChallenge(startTime)
              ? `Starts ${moment(startTime).format('MMM DD, YYYY')}`
              : `${howLongUntil(endTime)} Days Left`}
          </h5>
        )}{' '}
      </div>
      {badgeURL ? (
        <img className={styles.listBadgeIcon} src={badgeURL} />
      ) : (
        <AppMark />
      )}
    </div>
  );
};

export default ChallengeCardHeader;
